import { useCallback } from 'react';

import useListWithTempId from '@/hooks/useList/useListWithTempId';
import { FilterOperatorEnum } from '@/types/schema';

import { EMPTY_FILTER } from '../../consts';
import { FilterInputsD1, FilterInputsD2 } from '../../types';

export default function useFilters({
  filter,
  onGroupChange,
  index,
}: {
  filter: FilterInputsD1;
  onGroupChange: (item: FilterInputsD1, index: number) => void;
  index: number;
}) {
  const onOperatorChange = useCallback(
    (val: FilterOperatorEnum) => {
      onGroupChange(
        {
          ...filter,
          operator: val,
        },
        index,
      );
    },
    [filter, index, onGroupChange],
  );

  const onFilterChange = useCallback(
    (filters: FilterInputsD2[]) => {
      onGroupChange(
        {
          ...filter,
          filters,
        },
        index,
      );
    },
    [filter, index, onGroupChange],
  );

  const [filtersWithTempId, actions] = useListWithTempId(filter.filters, onFilterChange);

  const onAddFilter = useCallback(() => {
    actions.push(EMPTY_FILTER);
  }, [actions]);

  return {
    data: {
      filtersWithTempId,
    },
    methods: {
      onOperatorChange,
      onFilterChange: actions.onListInputChange,
      onAddFilter,
      onRemoveFilter: actions.onDelete,
    },
  };
}
